module.exports = __webpack_public_path__ + "media/images/flags/64/Denmark-1b5326c3d4f452a173323cf4a8e3d6c4.png";